import React from 'react';
import './style.css';

export const CardContent = ({ children }: any) => {
  return (
    <div className='card-form mt-4'>
      {children}
    </div>
  );
};
